import $ from 'jquery';

export default function clickable(target, selector = '.clickable') {

	$(selector).each(function(i, el) {

		var $item = $(el).find(target); // Target must be <a />
		if(typeof($item[0]) === 'undefined')
			$item.closest(target);

		if(typeof($item[0]) === 'undefined')
			$item = $(el).siblings().find(target);

		if(typeof($item[0]) === 'undefined')
			$item = $(this).find('a');

		if(typeof($item[0]) === 'undefined')
			return;

		$(el).off('click').on('click', function(e) {

			e.preventDefault();

			if($item.attr('target') === '_blank')
				window.open($item.attr('href'));
			else
				window.location = $item.attr('href');
		});
	});
}
